// Per-wave difficulty parameters as pure functions of the wave number.

import {
  ENEMY_BASE_COUNT,
  ENEMY_BASE_SPEED,
  ENEMY_COUNT_PER_WAVE,
  ENEMY_MAX_COUNT,
  ENEMY_MAX_SPEED,
  ENEMY_SPEED_PER_WAVE,
  MIRV_CHANCE_BASE,
  MIRV_CHANCE_MAX,
  MIRV_CHANCE_PER_WAVE,
  MIRV_INTRO_WAVE,
  SMARTBOMB_CHANCE_BASE,
  SMARTBOMB_CHANCE_MAX,
  SMARTBOMB_CHANCE_PER_WAVE,
  SMARTBOMB_INTRO_WAVE,
} from '../constants';

export interface WaveConfig {
  readonly count: number;
  readonly speed: number;
}

export function waveConfig(wave: number): WaveConfig {
  const count = Math.min(
    ENEMY_BASE_COUNT + wave * ENEMY_COUNT_PER_WAVE,
    ENEMY_MAX_COUNT,
  );
  const speed = Math.min(
    ENEMY_BASE_SPEED + wave * ENEMY_SPEED_PER_WAVE,
    ENEMY_MAX_SPEED,
  );
  return { count, speed };
}

/** Probability that an ICBM in this wave is a MIRV (0 before the intro wave). */
export function mirvChance(wave: number): number {
  if (wave < MIRV_INTRO_WAVE) return 0;
  return Math.min(
    MIRV_CHANCE_BASE + (wave - MIRV_INTRO_WAVE) * MIRV_CHANCE_PER_WAVE,
    MIRV_CHANCE_MAX,
  );
}

/** Probability that an enemy in this wave is a smart bomb (0 before intro). */
export function smartBombChance(wave: number): number {
  if (wave < SMARTBOMB_INTRO_WAVE) return 0;
  return Math.min(
    SMARTBOMB_CHANCE_BASE + (wave - SMARTBOMB_INTRO_WAVE) * SMARTBOMB_CHANCE_PER_WAVE,
    SMARTBOMB_CHANCE_MAX,
  );
}
